import { ScopeRegistry } from "./registry";
import { PermissionCatalog } from "./permissionsCatalog";

type PermissionKey = keyof typeof PermissionCatalog;

type ScopeRegistryMap = Partial<Record<string, Record<string, PermissionKey[]>>>;

const scopeRegistry: ScopeRegistryMap = ScopeRegistry;

function resolveConnectorPermissions(provider: string, scopes: string[]) {
  const providerMap = scopeRegistry[provider];

  if (!providerMap) return [];

  const permissions = new Set<PermissionKey>();

  scopes.forEach((scope) => {
    const mapped = providerMap[scope] || [];

    mapped.forEach((p) => permissions.add(p));
  });

  return [...permissions].map((key) => ({
    key,
    ...PermissionCatalog[key],
  }));
}

export default resolveConnectorPermissions;
